export function removeLeadingWhitespace(snippet: string): string {
  const formattedSnippet = snippet;
  const lastLine = formattedSnippet.split("\n").pop();
  const leadingSpaces = lastLine?.search(/\S/) ?? 0;
  const formatted = formattedSnippet
    .split("\n")
    .map((line) => {
      if (line?.search(/\S/) < leadingSpaces) {
        return line;
      } else {
        return line.slice(leadingSpaces);
      }
    })
    .join("\n");

  return formatted;
}
